"use strict";

angular.module('app.modals.infoGuide', [])

    .controller('infoGuideModalCtrl', ['$scope', '$state', 'close', 'state', '$translate','infoGuideStates',
        function ($scope, $state, close, state, $translate,infoGuideStates) {


            $scope.close = function () {
                close();
            }
            $scope.setState = function (a) {
                $scope.currentSubStateObject = a;
                $scope.currentSubState = a.state;
                $scope.$state = lang + '/' + a.state;
            }
            var lang = $translate.use();
            if (!lang) {
                lang = 'de';
            }

            // If manualy set from FunctionCall, use the state parameter.
            // This is for Popups etc, where we don't have e individual state

            if(!state){
                $scope.infoGuide = $state.current.infoGuide.state;
            }else{
                $scope.infoGuide = state;
            }

            $scope.currentInfoGuideStateOptions = infoGuideStates[$scope.infoGuide].options;
            $scope.infoGuideTitle = infoGuideStates[$scope.infoGuide].title;

            if (!infoGuideStates.hasOwnProperty($scope.infoGuide) || infoGuideStates[$scope.infoGuide].options.length == 0) {
                console.warn('No options for infoGuide at current State');
            } else {
                $scope.setState(infoGuideStates[$scope.infoGuide].options[0]);
            }
            ;




        }
    ])
    /* States for the info Guide */
    .constant('infoGuideStates',{
        "home":{
            title : 'INFOGUIDE_Home_Title',
            options : [
                {title:'INFOGUIDE_Home_IsPresent',state:'home_isPresent'},
                {title:'INFOGUIDE_Home_OutsideTemperatur',state:'home_outsideTemperature'},
                {title:'INFOGUIDE_Home_Menu',state:'home_menu'},
                {title:'INFOGUIDE_Home_Favorites',state:'home_favorites'},

            ]
        },
        "favorites":{
            title : 'INFOGUIDE_Favourites_Title',
            options : [
                {title:'INFOGUIDE_Favourites_Home',state:'favourites_home'},
                {title:'INFOGUIDE_Favourites_Back',state:'favourites_back'},
                {title:'INFOGUIDE_Favourites_Move',state:'favourites_move'},
                {title:'INFOGUIDE_Favourites_Edit',state:'favourites_edit'},
                {title:'INFOGUIDE_Favourites_SaveFavourite',state:'favourites_saveFavourite'},
                {title:'INFOGUIDE_Favourites_StartScreen',state:'favourites_startscreen'}
            ]
        },
        "rooms":{
            title : 'INFOGUIDE_Buildings_Title',
            options : [
                {title:'INFOGUIDE_Buildings_Home',state:'buildings_home'},
                {title:'INFOGUIDE_Buildings_Back',state:'buildings_back'},
                {title:'INFOGUIDE_Buildings_Move',state:'buildings_move'},
                {title:'INFOGUIDE_Buildings_Edit',state:'buildings_edit'},
                {title:'INFOGUIDE_Buildings_SaveFavourite',state:'buildings_saveFavourite'},


            ]
        },
        "sceneModalActionGroup":{
            title : 'INFOGUIDE_SceneModalActionGroup_Title',
            options : [
                {title:'INFOGUIDE_SceneModalActionGroup_Active',state:'sceneModalActionGroup_active'},
                {title:'INFOGUIDE_SceneModalActionGroup_ChaseAfter',state:'sceneModalActionGroup_chaseAfter'},
                {title:'INFOGUIDE_SceneModalActionGroup_Delay',state:'sceneModalActionGroup_delay'},
                {title:'INFOGUIDE_SceneModalActionGroup_ForceWrite',state:'sceneModalActionGroup_forceWrite'}
            ]
        },
        "sceneModalActionSetDatapoint":{
            title : 'INFOGUIDE_SceneModalActionSetDatapoint_Title',
            options : [
                {title:'INFOGUIDE_SceneModalActionSetDatapoint_Offset',state:'sceneModalActionSetDatapoint_offset'}
            ]
        },
        "sceneModalSceneSetting":{
            title : 'INFOGUIDE_SceneModalSceneSetting_Title',
            options : [
                {title:'INFOGUIDE_SceneModalSceneSetting_Interval',state:'sceneModalSceneSetting_interval'},
                {title:'INFOGUIDE_SceneModalSceneSetting_Read',state:'sceneModalSceneSetting_read'},
                {title:'INFOGUIDE_SceneModalSceneSetting_Write',state:'sceneModalSceneSetting_write'}
            ]
        },
        "sceneModalConditionSetting":{
            title : 'INFOGUIDE_SceneModalConditionSetting_Title',
            options : [
                {title:'INFOGUIDE_SceneModalConditionSetting_Active',state:'sceneModalConditionSetting_active'},
                {title:'INFOGUIDE_SceneModalConditionSetting_CompletionTime',state:'sceneModalConditionSetting_completionTime'},
                {title:'INFOGUIDE_SceneModalConditionSetting_ChaseAfter',state:'sceneModalConditionSetting_chaseAfter'},
                {title:'INFOGUIDE_SceneModalConditionSetting_AbortTime',state:'sceneModalConditionSetting_abortTime'},
                {title:'INFOGUIDE_SceneModalConditionSetting_RunOnce',state:'sceneModalConditionSetting_runOnce'},
                {title:'INFOGUIDE_SceneModalConditionSetting_Hysteresis',state:'sceneModalConditionSetting_hysteresis'}
            ]
        },
        "deviceManagement":{
            title : 'INFOGUIDE_Devices_Title',
            options : [
                {title:'INFOGUIDE_Devices_Home',state:'devices_home'},
                {title:'INFOGUIDE_Devices_Back',state:'devices_back'},
                {title:'INFOGUIDE_Devices_StartLearning',state:'devices_startLearning'},
                {title:'INFOGUIDE_Devices_EditDevice',state:'devices_editDevice'},
                {title:'INFOGUIDE_Devices_SaveFavourite',state:'devices_saveFavourite'},
                {title:'INFOGUIDE_Devices_deviceFilter',state:'devices_deviceFilter'},
                {title:'INFOGUIDE_Devices_learnedDevices',state:'devices_learnedDevices'},
                {title:'INFOGUIDE_Devices_signalStrength',state:'devices_signalStrength'},
                {title:'INFOGUIDE_Devices_deviceDatapointInScene',state:'devices_deviceDatapointInScene'},
                {title:'INFOGUIDE_Devices_deviceActivate',state:'devices_deviceActivate'},

            ]
        },
        "sceneList":{
            title : 'INFOGUIDE_Scenes_Title',
            options : [
                {title:'INFOGUIDE_Scenes_Home',state:'scenes_home'},
                {title:'INFOGUIDE_Scenes_Back',state:'scenes_back'},
                {title:'INFOGUIDE_Scenes_Add',state:'scenes_add'},
                {title:'INFOGUIDE_Scenes_Move',state:'scenes_move'},
                {title:'INFOGUIDE_Scenes_Edit',state:'scenes_edit'},
                {title:'INFOGUIDE_Scenes_SaveFavourite',state:'scenes_saveFavourite'},
                {title:'INFOGUIDE_Scenes_ControlSymbol',state:'scenes_controlSymbol'},
                {title:'INFOGUIDE_Scenes_ExecuteScene',state:'scenes_executeScene'},
                {title:'INFOGUIDE_Scenes_sceneActivate',state:'scenes_sceneActivate'},

            ]
        },
        "accessRequests":{
            title : 'INFOGUIDE_AccessRequests_Title',
            options : [
                {title:'INFOGUIDE_AccessRequests_Home',state:'accessRequests_home'},
                {title:'INFOGUIDE_AccessRequests_Back',state:'accessRequests_back'},
                {title:'INFOGUIDE_AccessRequests_Access',state:'accessRequests_access'},

            ]
        }
    })
    .factory('infoGuideModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (state) {

            return ModalService.showModal({
                templateUrl: "views/infoGuide/infoGuide.html",
                controller: 'infoGuideModalCtrl',
                inputs: {
                    state: state
                }
            });


        }
    }]);